import { render } from "./ColorGenerator.vue?vue&type=template&id=0f247bd0&scoped=true"
import script from "./ColorGenerator.vue?vue&type=script&lang=js"
export * from "./ColorGenerator.vue?vue&type=script&lang=js"

import "./ColorGenerator.vue?vue&type=style&index=0&id=0f247bd0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f247bd0"]])

export default __exports__